import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MinuteApprovalRuleMinDTO, MinuteRequestApprovalRuleDetailDTO } from '../interfaces/minute-request-approval-rule.interface';
import { MinuteRequestApprovalRuleService } from '../services/minute-request-approval-rule.service';
import { MatDialog } from '@angular/material/dialog';
import { RegisterMinuteApprovalRuleModalComponent } from '../components/register-minute-approval-rule-modal/register-minute-approval-rule-modal.component';
import { NewMinuteRequestConditionsViewModel, RemoveMinuteRequestApprovalConditionRequestDTO, UpdateMinuteRequestApprovalRuleConditionViewModel, UpdateMinuteRequestApprovalRuleViewModel } from '../interfaces/minute-request-approval-rule-manage.interface';
import Swal from 'sweetalert2';
import { UpdateMinuteRequestApprovalRuleComponent } from '../components/update-minute-request-approval-rule/update-minute-request-approval-rule.component';
import { UpdateMinuteRequestApprovalRuleConditionComponent } from '../components/update-minute-request-approval-rule-condition/update-minute-request-approval-rule-condition.component';
import { RegisterMinuteRequesApprovalConditionsComponent } from '../components/register-minute-reques-approval-conditions/register-minute-reques-approval-conditions.component';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { Permissions } from 'src/app/common/permissions';
import { O } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-minute-request-approval-rule-index',
  templateUrl: './minute-request-approval-rule-index.component.html',
  styleUrls: ['./minute-request-approval-rule-index.component.scss']
})
export class MinuteRequestApprovalRuleIndexComponent implements OnInit{
  public minuteApprovalRules$: Observable<MinuteApprovalRuleMinDTO[]>;

  public minuteRequestApprovalRuleDetail: MinuteRequestApprovalRuleDetailDTO | null = null;

  public allowedActions = {
    canViewAllApprovalRules: true,
    canRegister: true,
    canUpdate: true,
    canEnableDisable: true
  };


  constructor(private minuteRequestApprovalRuleService: MinuteRequestApprovalRuleService, private dialog: MatDialog, private authService: AuthService) {

  }

  ngOnInit(): void {
    this.checkAllowedActions();
    this.getAllMinuteApprovalRules();
  }

  public checkAllowedActions(){
    const canRegister = this.authService.hasPermission(Permissions.RegisterMinuteApprovalRule);
    const canUpdate = this.authService.hasPermission(Permissions.UpdateMinuteApprovalRule);
    const canEnableDisable = this.authService.hasPermission(Permissions.EnableDisableMinuteApprovalRule);
    const canViewAllApprovalRules = this.authService.hasPermission(Permissions.ViewAllMinuteApprovalRules);
    this.allowedActions = {
      ...this.allowedActions,
      canViewAllApprovalRules: canViewAllApprovalRules,
      canRegister: canRegister,
      canUpdate: canUpdate,
      canEnableDisable: canEnableDisable
    };
  }

  public getAllMinuteApprovalRules(){
    this.minuteApprovalRules$ = this.minuteRequestApprovalRuleService.getAllMinuteRequestApprovalRules();
  }

  public receiveMinuteRequestRuleApprovalToView(id: number | null){
    this.minuteRequestApprovalRuleDetail = null;
    if(id)
      this.getMinuteRequestRuleApprovalDetail(id);
    else 
      this.minuteRequestApprovalRuleDetail = null
  }

  public getMinuteRequestRuleApprovalDetail(id: number) {
    this.minuteRequestApprovalRuleService.getMinuteRequestApprovalRule(id)
    .subscribe({
      next:(detail) => {
        this.minuteRequestApprovalRuleDetail = detail;
      }
    })
  }

  public openRegisterMinuteApprovalRuleModal() {
    const modalRegisterClose$ = this.dialog.open(RegisterMinuteApprovalRuleModalComponent, {
      minWidth: '50vw',
      minHeight: '60vh',
      maxHeight: '90vh'
    }).afterClosed();
    modalRegisterClose$.subscribe({
      next: (res: boolean) => {
        if(res) 
          this.getAllMinuteApprovalRules();
      }
    })
  }

  public receiveMinuteApprovalRuleToUpdate(rule: MinuteApprovalRuleMinDTO) {
    this.minuteRequestApprovalRuleService.getMinuteRequestApprovalRule(rule.minuteRequestApprovalRuleId)
    .subscribe({
      next: (detail) => {
        this.openMinuteRequestApprovalRuleToUpdate(detail);
      }
    })
  }

  private openMinuteRequestApprovalRuleToUpdate(ruleDetail: MinuteRequestApprovalRuleDetailDTO) {
    const viewModel:  UpdateMinuteRequestApprovalRuleViewModel = {
      minuteRequestApprovalRuleId: ruleDetail.minuteRequestApprovalRuleId,
      name: ruleDetail.name,
      description: ruleDetail.description,
      priority: ruleDetail.priority,
      minApprovalRequired: ruleDetail.minApprovalRequired,
      roles: ruleDetail.roles.map(r => r.roleId)
    };
    const modalClose$ = this.dialog.open(UpdateMinuteRequestApprovalRuleComponent,{
      data: viewModel,
      minWidth: '50vw',
      maxWidth: '90vw'
    }).afterClosed();
    modalClose$.subscribe({
      next: (res: boolean) =>{
        if(res)
          this.getAllMinuteApprovalRules();
          this.getMinuteRequestRuleApprovalDetail(ruleDetail.minuteRequestApprovalRuleId);
      }
    })
  }

  /**
   * Recibir regla de aprobación de minuta para habilitar o inhabilitar
   * @param minuteApprovalRule regla de aprobación a habilitar/inhabilitar
   */
  public receiveMinuteApprovalRuleToEnableOrDisable(minuteApprovalRule: MinuteApprovalRuleMinDTO) {
    const operationStr: string = minuteApprovalRule.enabled ? 'Inhabilitar' : 'Habilitar';
    const request$ = minuteApprovalRule.enabled
    ? this.minuteRequestApprovalRuleService.disableMinuteRequestApprovalRule(minuteApprovalRule.minuteRequestApprovalRuleId)
    : this.minuteRequestApprovalRuleService.enableMinuteRequestApprovalRule(minuteApprovalRule.minuteRequestApprovalRuleId);
    Swal.fire({
      icon: 'question',
      title: `¿${operationStr} la regla ${minuteApprovalRule.name}?`,
      confirmButtonText: 'Sí',
      showDenyButton: true,
      denyButtonText: 'No',      
    }).then(r => {
      if(r.isConfirmed){
        Swal.showLoading();
        request$.subscribe({
          next: (res) => {
            this.getAllMinuteApprovalRules();
            Swal.fire({
              icon: 'success',
              text: res.resultMessage
            });
          },
          error:(err) => {
            Swal.fire({
              icon: 'error',
              text: err.error.resultMessage || 'Ha ocurrido un error inesperado'
            });
          }
        })
      }
    });
  }

  public receiveUpdateMinuteApprovalCondition(condition: UpdateMinuteRequestApprovalRuleConditionViewModel){
    const modal = this.dialog.open(UpdateMinuteRequestApprovalRuleConditionComponent,
      {
        data: condition,
        minWidth: '50vw',
        maxWidth: '90vw'  
      }
    );

    modal.afterClosed()
    .subscribe(res => {
      if(res) {
        this.getMinuteRequestRuleApprovalDetail(condition.minuteRequestApprovalRuleId);
      }
    })
  }

  public receiveEventRegisterMinuteRequestApprovalConditions(viewModel: NewMinuteRequestConditionsViewModel){
    const modal = this.dialog.open(RegisterMinuteRequesApprovalConditionsComponent,{
      data: viewModel,
      minWidth: '50vw',
      maxWidth: '90vw'  
    })
    modal.afterClosed()
    .subscribe(res => {
      if(res)
        this.getMinuteRequestRuleApprovalDetail(viewModel.minuteRequestApprovalRuleId);
    })
  }

  public receiceRemoveMinuteApprovalRuleCondition(request: RemoveMinuteRequestApprovalConditionRequestDTO) {
    Swal.fire({
      icon: 'question',
      title: '¿Desea eliminar esta condición?',
      confirmButtonText: 'Sí',
      showDenyButton: true,
      denyButtonText: 'No'
    }).then(r => {
      if(r.isConfirmed) {
        Swal.showLoading();
        this.minuteRequestApprovalRuleService.removeMinuteRequestApprovalRuleCondition(request)
        .subscribe({
          next:(res) => {
            this.getMinuteRequestRuleApprovalDetail(request.minuteRequestRuleId);
            Swal.fire({
              icon: 'success',
              text: res.resultMessage
            });
          },
          error: (err) => {
            Swal.fire({
              icon: 'success',
              text: err.error.resultMessage
            });
          }
        })
      }
    })
  }
}
